"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "amblar-don": {
    "cb80184e": [{
      "hkey": "968fda84",
      "slug": "amblar-don",
      "name": "Amblar-Don",
      "primary": true,
      "skipSearch": false
    }],
    "belvedere": [{
      "hkey": "968fda84",
      "slug": "amblar-don",
      "name": "Amblar-Don",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7dc2af46": [{
      "hkey": "968fda84",
      "slug": "amblar-don",
      "name": "Amblar-Don",
      "primary": true,
      "skipSearch": false
    }],
    "brusadi": [{
      "hkey": "968fda84",
      "slug": "amblar-don",
      "name": "Amblar-Don",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "674eb06b": [{
      "hkey": "968fda84",
      "slug": "amblar-don",
      "name": "Amblar-Don",
      "primary": true,
      "skipSearch": false
    }],
    "molini": [{
      "hkey": "968fda84",
      "slug": "amblar-don",
      "name": "Amblar-Don",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4cf5f72c": [{
      "hkey": "968fda84",
      "slug": "amblar-don",
      "name": "Amblar-Don",
      "primary": true,
      "skipSearch": false
    }],
    "villa-di-mezzo": [{
      "hkey": "968fda84",
      "slug": "amblar-don",
      "name": "Amblar-Don",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5641040a": [{
      "hkey": "968fda84",
      "slug": "amblar-don",
      "name": "Amblar-Don",
      "primary": true,
      "skipSearch": false
    }],
    "villa-di-sopra": [{
      "hkey": "968fda84",
      "slug": "amblar-don",
      "name": "Amblar-Don",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9bb736f1": [{
      "hkey": "968fda84",
      "slug": "amblar-don",
      "name": "Amblar-Don",
      "primary": true,
      "skipSearch": false
    }],
    "villa-di-sotto": [{
      "hkey": "968fda84",
      "slug": "amblar-don",
      "name": "Amblar-Don",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;